<template>
  <teleport to="#header-marquee">
    <div v-if="isShowMarquee" class="m22-event-marquee">
      <div class="marquee-container">
        <div class="marquee-text">
          <a v-for="n in 6" :key="n" :href="marquee.link">
            <span v-html="marquee.text" />
          </a>
        </div>
        <div class="marquee-text-second">
          <a v-for="n in 6" :key="n" :href="marquee.link">
            <span v-html="marquee.text" />
          </a>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';

const marquee = ref({});
const isShowMarquee = ref(false);

const versionNumber = generateVersionNumber();

let loadJson = '';
if (window.PictureContainer?.indexOf('-t') !== -1) {
  loadJson = `https://static.tpx.tw/sff-t/mercci22-vue3/json/marquee.json?v=${versionNumber}`;
} else {
  loadJson = `https://static.tpx.tw/sff/mercci22/json/marquee.json?v=${versionNumber}`;
}

// const loadJson = API_URL.MARQUEE;

let marqueeArray = [];

async function getMarquee() {
  const now = Date.now();

  try {
    const res = await axios.get(loadJson);
    marqueeArray = res.data.Response;

    marqueeArray.forEach((element) => {
      const startTime = new Date(element.startTime).getTime();
      const endTime = new Date(element.endTime).getTime();
      if (now >= startTime && now <= endTime) {
        marquee.value = element;
        isShowMarquee.value = true;
      }
    });

    Object.entries(marquee.value.themeColors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  } catch (err) {
    isShowMarquee.value = false;
  }
}

function generateVersionNumber() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const date = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');

  return `${year}${month}${date}${hour}`;
}

getMarquee();
</script>
